/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Remove_SuccessInputs */



/**
* | output |
* | --- |
* | "Event group has been removed." |
*
* @param {Event_Group_Options_Remove_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_remove_success = /** @type {((inputs?: Event_Group_Options_Remove_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Remove_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le groupe d'événements a été supprimé.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Ereignisgruppe wurde entfernt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il gruppo di eventi è stato rimosso.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группа событий удалена.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se ha eliminado el grupo de eventos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("活动组已被移除。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント グループが削除されました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट ग्रुप को हटा दिया गया है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O grupo de eventos foi removido.")
	return /** @type {LocalizedString} */ ("Event group has been removed.")
});